import { render } from "./BpmnEvent.vue?vue&type=template&id=fca10b90&scoped=true"
import script from "./BpmnEvent.vue?vue&type=script&lang=js"
export * from "./BpmnEvent.vue?vue&type=script&lang=js"

import "./BpmnEvent.vue?vue&type=style&index=0&id=fca10b90&scoped=true&lang=css"
import "./BpmnEvent.vue?vue&type=style&index=1&id=fca10b90&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fca10b90"]])

export default __exports__